import FlexBox from '@/atomic-components/FlexBox';
import { getColor } from '@/utils/theme/colors';
import { getStyle } from '@/utils/theme/fonts';
import { LencoTypography } from '@/atomic-components/LencoTypography';
import { Box } from '@mui/system';
import { useRouter } from 'next/router';
import { emitMoeEvent } from '@/utils/dataLayer';

type ProductGroups = {
	productGroups: any;
	rentStartingPrice: string;
};

const ProductGroups = (props: ProductGroups) => {
	const { productGroups } = props;

	type VerticalMapper = {
		RENT: string[];
		BUY_NEW: string[];
		BUY_REFURBISHED: string[];
	};

	const VerticalMapper: VerticalMapper = {
		RENT: ['Rent', 'Starting at'],
		BUY_NEW: ['Buy', 'Brand New at'],
		BUY_REFURBISHED: ['Buy', 'Refurbished at'],
	};

	const productGroupKeys = Object.keys(productGroups);

	const router = useRouter();

	return (
		<FlexBox direction='column' sx={{ marginBottom: '40px' }}>
			{productGroupKeys.map((pg, index) => {
				const verticalName =
					VerticalMapper[
						productGroups[pg].lineOfProduct as keyof VerticalMapper
					][0];
				const productStartingPrice =
					verticalName == 'Rent'
						? productGroups[pg]?.upfrontOffers?.paymentPlans?.filter((x:any)=>{return x.tenure == productGroups[pg]?.upfrontOffers?.defaultTenure})[0]?.monthlyRental?.displayValue
						: productGroups[pg]?.priceBreakUp?.postTax.displayValue;
				return (
					<FlexBox direction='column' key={index}>
						<Box sx={{ width: '100%', borderTop: '1px solid #D9D9D9' }}></Box>
						<FlexBox
							sx={{
								alignContent: 'center',
								width: '100%',
								padding: '16px 0px 16px 16px',
								cursor: 'pointer',
								'&:hover': {
									background: '#FFFFFF',
									color: getColor('Minty +1'),
									boxShadow: '0px 8px 8px rgba(34, 34, 34, 0.1)',
									'#type1': {
										color: getColor('Minty +1'),
									},
									'#type2': {
										color: getColor('Minty +1'),
									},
								},
							}}
							onClick={() => {
								emitMoeEvent('PDP LOP Radio Selected', {
									from_lop: router.query.slug,
									to_lop: productGroups[pg].permalink,
								});
								router.push(`/products/${productGroups[pg].permalink}`);
							}}
						>
							<Box
								sx={{
									width: '14px',
									height: '14px',
									borderRadius: '50%',
									border: '1px solid black',
									marginTop: '5px',
								}}
							></Box>
							<LencoTypography
								id='type1'
								sx={{
									...getStyle('H14_SemiBold'),
									color: '#222222',
									paddingLeft: '8px',
								}}
							>
								{verticalName}{' '}
								<LencoTypography
									component='span'
									id='type2'
									sx={{
										...getStyle('H14_Medium'),
										color: getColor('Gray -1'),
									}}
								>
									{
										VerticalMapper[
											productGroups[pg].lineOfProduct as keyof VerticalMapper
										][1]
									}{' '}
									{productStartingPrice}
								</LencoTypography>
							</LencoTypography>
						</FlexBox>
					</FlexBox>
				);
			})}
			<Box sx={{ width: '100%', borderTop: '1px solid #D9D9D9' }}></Box>
		</FlexBox>
	);
};

export default ProductGroups;
